// extracted by mini-css-extract-plugin
export default {"reviewModal":"styles_reviewModal__ej6q8","button":"styles_button__0Nfzy"};